import {
  BOOKING_MIX_SEGMENT_COLORS,
  WEEKLY_REVENUE_CHART_COLOR,
} from 'pages/pga-coach/dashboard/dashboard-colors'

export const WEEKLY_REVENUE_WEEKS = 8

export { WEEKLY_REVENUE_CHART_COLOR }

export const GROWTH_PERIOD_LABELS = {
  LAST_8_WEEKS: 'Last 8 weeks',
  THIS_MONTH: 'This month',
}

export const BOOKING_MIX_CATEGORIES = {
  PRIVATE: 'private',
  GROUP: 'group',
  PACKAGES: 'packages',
}

export const BOOKING_MIX_LABELS = {
  [BOOKING_MIX_CATEGORIES.PRIVATE]: 'Private',
  [BOOKING_MIX_CATEGORIES.GROUP]: 'Group',
  [BOOKING_MIX_CATEGORIES.PACKAGES]: 'Packages',
}

export const BOOKING_MIX_COLORS = {
  [BOOKING_MIX_CATEGORIES.PRIVATE]: BOOKING_MIX_SEGMENT_COLORS.private,
  [BOOKING_MIX_CATEGORIES.GROUP]: BOOKING_MIX_SEGMENT_COLORS.group,
  [BOOKING_MIX_CATEGORIES.PACKAGES]: BOOKING_MIX_SEGMENT_COLORS.packages,
}
